export default __webpack_public_path__ + "static/media/voltera_ΦΑ.26ea02bd.png";